document.addEventListener('DOMContentLoaded', () => {
    
    const collection = {
        init: function () {
            this.section = document.querySelector('#collection')
            this.sectionId = this.section.dataset.section;

            this.filters = document.querySelectorAll('.collection-filter');
            this.filters.forEach(filter => {
                filter.addEventListener('change', this.onFilterChange.bind(this));
            })

            this.bridges = document.querySelectorAll('.bridge');
            this.bridges.forEach(bridge => {
                bridge.addEventListener('click', this.onBridge.bind(this));
            })

            this.initPages();
        },

        initPages: function () {
            this.pages = this.section.querySelectorAll('.pages .item');

            this.pages.forEach(page => {
                page.addEventListener("click", this.onPageChange.bind(this));
            })
        },

        onPageChange: function (e) {
            e.preventDefault();
            let target = e.target.closest('.item') || e.target;
            this.update(target.dataset.page);
        },

        onFilterChange: function (e) {
            e.preventDefault();
            this.update(1);
        },

        update: function (page) {
            let url = '';
            for(i=0;i<this.filters.length;i++){
                if(i>0) url += '&'
                if(this.filters[i].name == 'page' && page) url += `page=${page}`;
                else url += `${this.filters[i].name}=${this.filters[i].value}`;
            }

            let urlToFetch = `${url}&section_id=${this.sectionId}`;

            setActive(this.section);
            fetch(`?${urlToFetch}`)
                .then(response => response.text())
                .then(response => {
                    const html = new DOMParser().parseFromString(response, 'text/html');
                    const source = html.querySelector('#collection');
                    const destination = this.section;
                    if(source && destination) destination.innerHTML = source.innerHTML;

                    unsetActive(this.section);
                    collection.initPages();
                    window.scroll({
                        top: 0,
                        behavior: 'smooth'
                    });
                    window.history.replaceState({ }, '', `?${url}`);
                })
        },

        onBridge: function (e) {
            e.preventDefault();
            const target = e.target.closest('.bridge') || e.target;
            
            setActive(this.section);
            fetch(`/collections/${target.dataset.collection}`)
                .then(response => response.text())
                .then(response => {
                    const html = new DOMParser().parseFromString(response, 'text/html');
                    const source = html.querySelector('main');
                    const destination = document.querySelector('main');

                    if(source && destination) destination.innerHTML = source.innerHTML;

                    collection.init();
                    window.scroll({
                        top: 0,
                        behavior: 'smooth'
                    });
                    window.history.replaceState({ }, '', `/collections/${target.dataset.collection}`);
                })
        }
    }
    collection.init();

}, { passive: true });